import { render } from "./SwitchingBonus.vue?vue&type=template&id=af125094&scoped=true"
import script from "./SwitchingBonus.vue?vue&type=script&lang=js"
export * from "./SwitchingBonus.vue?vue&type=script&lang=js"

import "./SwitchingBonus.vue?vue&type=style&index=0&id=af125094&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af125094"]])

export default __exports__